import React, { useState, useRef, useEffect } from 'react';
import './CommandModal.css';

function CommandModal({ command, onClose, commandCardRef  }) {
  const modalRef = useRef(null);
    const [modalPosition, setModalPosition] = useState({ top: 1650, left: 550 });
    useEffect(() => {
        if (commandCardRef && commandCardRef.current) {
            const rect = commandCardRef.current.getBoundingClientRect();
            setModalPosition({
                top: rect.top + window.scrollY,
                left: rect.left,
            });
        }
    }, [commandCardRef]);
    if (!command) {
        return null;
    }
      return (
        <div className="command-modal-overlay" onClick={onClose}>
            <div className="command-modal-content"   style={{ top: modalPosition.top, left: modalPosition.left }}  onClick={(e) => e.stopPropagation()} ref={modalRef} >
                <div className="command-modal-header">
                    <h2>{command.name}</h2>
                     <span className="command-modal-close" onClick={onClose}>×</span>
               </div>
                <div className="command-modal-body">
                       <img src={command.image} alt="Тут нет фоточки :)" className="command-modal-image" loading="lazy"/>
                        <p>{command.longDescription || command.description}</p>
                </div>
            </div>
        </div>
    );
}

export default CommandModal;